"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attributes = void 0;
const react_1 = __importDefault(require("react"));
const attribute_component_1 = require("./attribute.component");
const attributes_styles_1 = require("./attributes.styles");
const consolidated_list_utils_1 = require("../consolidated-list.utils");
const Attributes = ({ attributes, }) => {
    const list = (0, consolidated_list_utils_1.parseList)(attributes, 'name');
    return (react_1.default.createElement(attributes_styles_1.StyledAttributeListContainer, null, list.map((attributes, index) => (react_1.default.createElement("div", { className: "list-column", key: index }, attributes.map((attribute) => (react_1.default.createElement(attribute_component_1.Attribute, { key: attribute.id, attribute: attribute }))))))));
};
exports.Attributes = Attributes;
exports.default = exports.Attributes;
